import React from 'react';

const ConfirmationModal = ({ onCancel, onConfirm, message }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Confirm Cancellation</h3>
        <p>{message}</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
          <button onClick={onCancel}>No</button>
          <button onClick={onConfirm} style={{ backgroundColor: 'red', color: 'white' }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
